import { HandoverHandoverSettingsData } from './handover-handover-settings-data';
import { ScaffoldDetails } from './scaffold-details';
import { SiteDetails } from './site-details';
import { HandoverScaffoldData } from './handover-scaffold-data';
import { HandoverIdentifiedRiskActivityData } from './handover-identified-risk-activity-data';
import { StaffSignatureData } from './staff-signature-data';
import { CustomerSignatureData } from './customer-signature-data';
import { SiteDocumentStatusEnum } from '../../enum/site-document-status.enum';
import { CustomerAttachmentData } from './customer-attachment-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class HandoverActivityDetails {
  HandoverHandoverSettingsData: HandoverHandoverSettingsData[];
  ActivityId: string;
  ScaffoldDetails: ScaffoldDetails;
  SiteDetails: SiteDetails;
  ActivityDateTime: string;
  HandoverId: string;
  NextInspectionDate: string;
  RisksIdentified: boolean;
  Scaffolds: HandoverScaffoldData[];
  HandoverComments: string;
  HirePeriod: number;
  IdentifiedRiskDetails: string;
  Media: string[];
  IdentifiedRisks: HandoverIdentifiedRiskActivityData[];
  HandoverQuestionsAsked: string[];
  HandoverReference: string;
  StaffSignature: StaffSignatureData;
  CustomerSignature: CustomerSignatureData;
  When: string;
  Status: SiteDocumentStatusEnum;
  SiteId: string;
  CustomerId: string;
  CustomerAttachment: CustomerAttachmentData[];
}


